import { Controller } from "@hotwired/stimulus"

import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

// Default theme
import '@splidejs/splide/css';

// or only core styles
import '@splidejs/splide/css/core';

// Connects to data-controller="splide"
export default class extends Controller {
  static targets = ["carousel"]
  static values = {
    carouselType: { type: String, default: "loop" },
    perPage: { type: Number, default: 4 },
    perMove: { type: Number, default: 1 },
    gap: { type: String, default: "1rem" },
    padding: { type: Object, default: { left: 0, right: 0 } },
    pagination: { type: Boolean, default: true },
    start: { type: Number, default: 0 },
    focus: { type: String, default: "center" },
    autoplay: { type: Boolean, default: false },
    drag: { type: Boolean, default: true },
    interval: { type: Number, default: 3000 },
    pauseOnHover: { type: Boolean, default: true },
    mobileOptions: {
      type: Object,
      default: {
        perPage: 1,
        padding: { left: 0, right: 0 }
      }
    },
    grid: { type: Object, default: {} }
  }

  connect() {
    new Splide(this.carouselTarget, {
      type: this.carouselTypeValue,
      perPage: this.perPageValue,
      perMove: this.perMoveValue,
      pagination: this.paginationValue,
      focus: this.focusValue,
      start: this.startValue,
      gap: this.gapValue,
      padding: this.paddingValue,
      rewind: true,
      autoplay: this.autoplayValue,
      interval: this.intervalValue,
      pauseOnHover: this.pauseOnHoverValue,
      drag: this.dragValue,
      breakpoints: {
        640: this.mobileOptionsValue
      },
      grid: this.gridValue,
    }).mount();
  }
}
